import { render, staticRenderFns } from "./BulkImportStep2.vue?vue&type=template&id=5984d69a&"
import script from "./BulkImportStep2.vue?vue&type=script&lang=js&"
export * from "./BulkImportStep2.vue?vue&type=script&lang=js&"
import style0 from "./BulkImportStep2.vue?vue&type=style&index=0&id=5984d69a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports